import {Grid, Typography} from '@mui/material';
import LandingCta from '../landing/LandingCta';
import AboutMission from './AboutMission';
import AboutProduct from './AboutProduct';
import AboutTimeline from './AboutTimeline';

const aboutPageContent = [
  AboutMission,
  AboutProduct,
  // AboutTeam,
  AboutTimeline,
  // AboutTestimonials
];

export default function AboutPage() {
  return (
    <Grid container direction="column" spacing={2}>
      <Typography variant="h1" component="h1" gutterBottom align="center">
        About Etsy Seller Tool
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom align="center" color="text.secondary" sx={{mb: 6}}>
        Empowering Etsy sellers to grow their businesses and achieve their dreams
      </Typography>
      <Grid container spacing={8}>
        {aboutPageContent.map((Component) => (
          <Grid size={{xs: 12}} key={`AboutPage-${Component.name}`}>
            <Component />
          </Grid>
        ))}
      </Grid>
      <LandingCta />
    </Grid>
  );
}
